import axios from '../helpers/axios';
import { IClosingCalendarEvents, IGetCalendarEvent } from "../models/calendar";
import { logError } from "../services";
import { IDropdownResponse, IResponse } from "../models";
import qs from 'querystring';


const baseUrl = "/api/closing-calendar";

export const getClosingCalendarEvents = async (filters?: {
  startDate: Date | string;
  endDate: Date | string;
  eventTypes: any[];
  searchTerm: string;
}): Promise<IGetCalendarEvent[]> => {
    try {
      const response = await axios.get(`${baseUrl}`, {params: {
        startDate: (filters?.startDate as Date).toJSON(),
        endDate: (filters?.endDate as Date).toJSON(),
        eventTypes: filters?.eventTypes,
        searchTerm: filters?.searchTerm
      },
      paramsSerializer: params => qs.stringify(params)
    });
      return response.data;
    } catch (error) {
      logError(error, 'getClosingCalendarEvents failed');
      return Promise.reject(error);
    }
  };

  export const updateClosingCalendarEvents = async (closingCalendarEvents: IClosingCalendarEvents[] ): Promise<IResponse<IGetCalendarEvent[]>> => {
      try {
        const response = await axios.put(`${baseUrl}/events`, {closingCalendarEventModifications: closingCalendarEvents} );
        return response.data;
      } catch (error) {
        logError(error, 'updateClosingCalendarEvents failed');
        return Promise.reject(error);
      }
    };

    export const getEventTypes = async (): Promise<IDropdownResponse[]> => {
      try {
        const response = await axios.get(`${baseUrl}/event-types`);
        return response.data;
      } catch (error) {
        logError(error, 'getEventTypes failed');
        return Promise.reject(error);
      }
    }